import {RadioGroupKeyValue} from "./radioGroupKeyValue";

// Simple key value with no custom input
export class SimpleRadioGroupKeyValue extends RadioGroupKeyValue {
  get hasCustomInput(): boolean {
    return false;
  }

  renderCustomInput(): JSX.Element | null {
    return null;
  }

  get enteredValue(): string {
    return this.value;
  }
}
